import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';
import { EcoSelectStation } from '@/comp';
import { EPButton } from '@/components';
import EnergySavingsReport from './EnergySavings/EnergySavingsReport';

const ReportsPage = observer(() => {
  const { permissionStore } = useStores();
  const navigate = useNavigate();
  const dateOptions: Intl.DateTimeFormatOptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  const [selectedDate] = useState(new Date().toLocaleDateString('en-EN', dateOptions));

  const hasViewPermission = permissionStore.isAuth(permissions.VIEW_STATION_REPORTS);

  useEffect(() => {
    !hasViewPermission && navigate('/home');
  }, [hasViewPermission]);

  if (!hasViewPermission) navigate('/home');

  return (
    <Container>
      <div className="top-row">
        <span>
          <EcoSelectStation requiredPermission={permissions.VIEW_STATION_REPORTS} />
        </span>
        <EPButton className="date-selector">{selectedDate}</EPButton>
        {/* TODO change to DatePicker (or EPRangePicker) when possible. */}
      </div>
      <EnergySavingsReport />
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: ${({ theme: { token } }) => token.paddinXL}px;
  flex-direction: column;
  align-items: flex-start;

  .top-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;

    .date-selector {
      display: flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      margin-left: ${({ theme: { token } }) => token.margin}px;
      margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }
`;

export default ReportsPage;
